import { __assign } from "tslib";
/* I140 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Topics = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M13.736 14.41l4.737 7.5h-2.365l-2.373-3.756-2.372 3.756H9l4.736-7.5zm-9.018-3.8351L6.4085 14.2l-2.718 1.2675L2 11.8424l2.718-1.2675zM18.3746 2L22 9 8.7309 14.4458 6.0227 8.638 18.3747 2z", fillRule: "evenodd" }))));
};
Topics.displayName = 'Topics';
export default Topics;
//# sourceMappingURL=Topics.js.map